var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-image-toggle"},[_c('h3',[_vm._v("Activate product images")]),_c('div',{staticClass:"product-check",on:{"click":_vm.update}},[_c('div',{staticClass:"check",class:{ active: _vm.displayProductImages === true }}),_c('label',[_vm._v("Display product images if available")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }